import React from "react";

const PreviewStudyListIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_7728_862)">
        <path
          d="M1 17C0.45 17 -0.0208333 16.8042 -0.4125 16.4125C-0.804167 16.0208 -1 15.55 -1 15V1C-1 0.45 -0.804167 -0.0208333 -0.4125 -0.4125C-0.0208333 -0.804167 0.45 -1 1 -1H15C15.55 -1 16.0208 -0.804167 16.4125 -0.4125C16.8042 -0.0208333 17 0.45 17 1V15C17 15.55 16.8042 16.0208 16.4125 16.4125C16.0208 16.8042 15.55 17 15 17H1ZM1 15H15V1H1V15ZM8 12.0875C6.63333 12.0875 5.4125 11.7167 4.3375 10.975C3.2625 10.2334 2.48333 9.27086 2 8.08752C2.48333 6.90419 3.2625 5.94169 4.3375 5.20002C5.4125 4.45836 6.63333 4.08752 8 4.08752C9.36667 4.08752 10.5875 4.45836 11.6625 5.20002C12.7375 5.94169 13.5167 6.90419 14 8.08752C13.5167 9.27086 12.7375 10.2334 11.6625 10.975C10.5875 11.7167 9.36667 12.0875 8 12.0875ZM8 10.5875C8.93333 10.5875 9.78333 10.3667 10.55 9.92502C11.3167 9.48336 11.9167 8.87086 12.35 8.08752C11.9167 7.30419 11.3167 6.69169 10.55 6.25002C9.78333 5.80836 8.93333 5.58752 8 5.58752C7.06667 5.58752 6.21667 5.80836 5.45 6.25002C4.68333 6.69169 4.08333 7.30419 3.65 8.08752C4.08333 8.87086 4.68333 9.48336 5.45 9.92502C6.21667 10.3667 7.06667 10.5875 8 10.5875ZM8 9.58752C8.41667 9.58752 8.77083 9.44169 9.0625 9.15002C9.35417 8.85836 9.5 8.50419 9.5 8.08752C9.5 7.67086 9.35417 7.31669 9.0625 7.02502C8.77083 6.73336 8.41667 6.58752 8 6.58752C7.58333 6.58752 7.22917 6.73336 6.9375 7.02502C6.64583 7.31669 6.5 7.67086 6.5 8.08752C6.5 8.50419 6.64583 8.85836 6.9375 9.15002C7.22917 9.44169 7.58333 9.58752 8 9.58752Z"
          fill={(props.active != undefined && props.active != null && props.active == true) ?"rgb(20 123 255)":"#DADADA"}
        />
      </g>
      <defs>
        <clipPath id="clip0_7728_862">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PreviewStudyListIcon;
